// extracted by mini-css-extract-plugin
module.exports = {"root":"_9rqNY0gx","input":"VFUpwfcR","text":"R4a6I+wt","title":"mih+jWf2"};